import { createAsyncThunk } from '@reduxjs/toolkit';

const getUsers = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/users');
    return result;
  } catch (e) {}
};

const getRecruiters = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('users/recruiters');
    return result;
  } catch (e) {}
};

const getOutreachUsers = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('outreaches/users');
    return result;
  } catch (e) {}
};

const getExternalUsers = async (_payload, { extra: { http } }) => {
  try {
    const result = await http.get('/users?scope=external');
    return result;
  } catch (e) {}
};

export const fetchUsers = createAsyncThunk('users/fetch/all', getUsers, {
  condition: (_userId, { getState }) => {
    const { users } = getState();
    return users?.data?.length === 0;
  },
});
export const fetchRecruiters = createAsyncThunk(
  'recruiters/fetch/all',
  getRecruiters,
  {
    condition: (_userId, { getState }) => {
      const { users } = getState();
      return users?.recruiters?.data?.length === 0;
    },
  }
);
export const fetchOutreachUsers = createAsyncThunk(
  'outreachUsers/fetch/all',
  getOutreachUsers,
  {
    condition: (_userId, { getState }) => {
      const { users } = getState();
      return users?.outreachUsers?.data?.length === 0;
    },
  }
);

export const fetchExternalUsers = createAsyncThunk(
  'externalUsers/fetch/all',
  getExternalUsers
);
